import { ContentfulLivePreview } from "@contentful/live-preview";

/**
 * Returns a hook to use Contentful's Inspector Mode specifying the entry once.
 *
 * @see https://www.contentful.com/developers/docs/tutorials/general/live-preview/#set-up-inspector-mode
 */
export function useInspectorMode(entryId: string) {
  return {
    getProps: (fieldId: string) => {
      return ContentfulLivePreview.getProps({ entryId: entryId, fieldId });
    },
  };
}
